import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { AccordionItem } from './Accordion';
import { BuyButton } from './BuyButton';
export function Chapters() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const chapters = [{
    title: '📖 CAPÍTULO 1: Los Errores que Frenan a la Mayoría de los Laterales',
    content: ['Los 10 errores más comunes del lateral amateur', 'Cuándo subir y cuándo quedarse', 'Errores de posicionamiento y timing', 'Cómo leer el contexto antes de actuar', 'Cuándo acelerar y cuándo pausar', 'Cómo interpretar espacios, rivales y compañeros', 'Cómo identificar tus puntos débiles', 'La toma de decisiones como ventaja competitiva']
  }, {
    title: '📖 CAPÍTULO 2: Ataque: Cómo Ser Determinante en Fase Ofensiva',
    content: ['Cuándo proyectarte', 'Cuándo doblar y cuándo fijar', 'Superposiciones exteriores e interiores', 'Relación con extremos y volantes', 'Cómo generar superioridades numéricas', 'Cómo romper líneas desde la banda', 'Cómo llegar a zona de asistencia', 'Centros que generan peligro', 'Aplicaciones prácticas según el sistema de juego']
  }, {
    title: '📖 CAPÍTULO 3: Defensa: Cómo Ganar Duelos y Proteger Tu Banda',
    content: ['Defensa 1 vs 1', 'Perfil corporal y orientación defensiva', 'Distancias correctas', 'Coberturas y vigilancias', 'Cómo defender extremos rápidos', 'Cómo defender extremos encaradores', 'Defensa de centros laterales', 'Contraataques y transiciones defensivas', 'Cambios de orientación', 'Cómo convertirte en un defensor confiable']
  }, {
    title: '📖 CAPÍTULO 4: Situaciones Reales que Todo Lateral Vive',
    content: ['Qué hacer cuando...', 'Tu extremo no ayuda', 'Quedás en un 2 vs 1', 'Te atacan constantemente', 'Tu equipo está ganando', 'Tu equipo está perdiendo', 'Estás condicionado por una amarilla', 'Tu central no cubre', 'El rival cambia de sistema', 'Quedan 10 minutos de partido', 'Necesitás cerrar un resultado']
  }, {
    title: '📖 CAPÍTULO 5: El Lateral Moderno: Jugar por Dentro, Adaptarse y Destacar',
    content: ['El lateral interior', 'Cómo ocupar espacios interiores', 'Participación en salida de balón', 'Creación de líneas de pase', 'Escaneo corporal', 'Toma de información antes de recibir', 'Adaptación táctica según el sistema', 'Cómo convertirse en un mediocampista adicional', 'Toma de decisiones bajo presión', 'Cómo pensar el juego como un lateral moderno']
  }];
  return <section className="py-16 px-4 bg-[#f8f9fa]" data-id="element-39">
      <div className="max-w-3xl mx-auto" data-id="element-40">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl text-center text-[#1a3d1f] mb-10 uppercase" data-id="element-41">
          Lo que vas a aprender
        </motion.h2>

        <div className="mb-10" data-id="element-42">
          {chapters.map((chapter, index) => <AccordionItem key={index} title={chapter.title} content={chapter.content} isOpen={openIndex === index} onToggle={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-43" />)}
        </div>

        <BuyButton data-id="element-44" />
      </div>
    </section>;
}